import {
	getApiUrl,
	type OrderVerticalResponseDto,
} from "Infrastructure/Api/Api";
import { FadeInTopAnimation } from "Shared/Components/Animation/In/FadeInTopAnimation";
import { BlankCard } from "Shared/Components/Cards/BlankCard";
import { Box, Stack, Typography } from "@mui/material";
import { motion } from "motion/react";

type MarketCardProps = {
	vertical: OrderVerticalResponseDto;
	index: number;
	onClick: () => void;
};

export function VerticalSelectCard({
	vertical,
	index,
	onClick,
}: MarketCardProps) {
	return (
		<FadeInTopAnimation delay={index * 0.15}>
			<motion.div
				initial={{ y: 0, opacity: 1 }}
				transition={{
					duration: 0.15,
				}}
				whileHover={{
					scale: 1.05,
					transition: { duration: 0.15 },
				}}
				whileTap={{ scale: 0.98 }}
			>
				<Box maxWidth="300px" sx={{ cursor: "pointer" }} onClick={onClick}>
					<BlankCard>
						<Stack
							justifyContent="center"
							alignItems="center"
							padding="8px 12px"
						>
							<Box width="60px" height="60px" padding="6px" color="primary">
								<img
									src={`${getApiUrl()}${vertical.iconPath}`}
									alt="vertical icon"
									width="100%"
									height="100%"
								/>
							</Box>
							<Typography mt={1} variant="h6" fontWeight={600}>
								{vertical.name}
							</Typography>
						</Stack>
					</BlankCard>
				</Box>
			</motion.div>
		</FadeInTopAnimation>
	);
}
